import React, { useCallback, useMemo } from 'react'
import Chips from '../chips';

const FileChip = ({ files, removeFile, selectFileContent, validations }) => {
  
  // on remove of any file
  const onClickCancel = useCallback((event, fileData) => {
    event.stopPropagation();
    event.preventDefault();
    removeFile(fileData);
  }, [removeFile])
  
  // chips data for Chips
  const chipsData = useMemo(() => (files||[]).map(fileData=>({
    id: fileData.Key,
    name: (fileData.displayName && fileData.displayName.length >= 13) ? fileData.displayName.slice(0,5) + "..." + fileData.displayName.slice(-5) : fileData.displayName,
    withCross: true,
    onClickCancel: (event) => onClickCancel(event, fileData)
  })), [files, onClickCancel])

  return (
    <div className="files-container">
      {!files.length ? (
        <div className="files empty-data">
          <div className="select-file-content">
            {selectFileContent}
            <p className="file-size-validation">{validations?.maxUploadFileSize ? ` (Upto ${validations?.maxUploadFileSize}mb)` : ""}</p>
          </div>
        </div>
      ) : (
        <div className="files with-data">
          {!!files.length && (
            <Chips chipsData={chipsData} hideLabel />
          )}
        </div>
      )}
    </div>
  );
};

export default FileChip